import { Component, input } from "@angular/core";
import { EvTooltipModule } from "ev-tooltip";
import { StatisticPanel } from "src/models/map/demographic-area-data";

@Component({
    selector: "statistics-panel",
    imports: [EvTooltipModule],
    templateUrl: "./statistics-panel.component.html",
    styleUrl: "./statistics-panel.component.scss",
})
export class StatisticsPanelComponent {
    panelData = input<StatisticPanel>();
}

